import { PaymentMethod } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { InvoicePaymentMethod } from '../types';

const PAYU_PAYMENT_METHOD_DESCRIPTION = 'PayU';

export const getInvoicePaymentMethod = (paymentMethod: PaymentMethod | undefined): InvoicePaymentMethod => {
   switch (paymentMethod?.methodType) {
      case 'BANK_TRANSFER':
         return { type: 'TRANSFER', description: paymentMethod.description };
      case 'CASH':
         return { type: 'CASH', description: paymentMethod.description };
      case 'OTHER':
         return { type: 'OTHER', description: paymentMethod.description };
      case 'PAYMENT_CARD':
         return { type: 'CARD', description: paymentMethod.description };
      default:
         return { type: 'OTHER', description: PAYU_PAYMENT_METHOD_DESCRIPTION };
   }
};
